import script from "./FooterView.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=be7c185e&lang=css"
import "./FooterView.vue?vue&type=style&index=1&id=be7c185e&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/spepi.cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be7c185e"]])

export default __exports__